<div class="auditItem Assignment-Category">
  <div class="auditIconWrap">
    <div class="auditIcon">
      <mat-icon svgIcon="log"></mat-icon>
      <span class="log-status" appLogStatusStyle [status]="log.status"></span>
    </div>
  </div>
  <div class="auditInfo">
    <div class="auditHeader"><span class="auditTimestamp">{{log.updated |  formatDateWithTimezone | async}}</span> <span
        (click)="isSelected ? unselected.emit() : selected.emit()" class="showAuditDetails">
        <mat-icon>info</mat-icon>
      </span></div>
    <div class="auditDescription">
      {{log.leads.length}} lead generat{{log.leads.length == 1 ? 'o' : 'i'}}
    </div>
    <div class="auditCommentWrap">

      <div class="auditCommentText">
        <p>
          {{log.exception}}
        </p>
      </div>
    </div>
  </div>
</div>
